import '@babel/polyfill';
import Vue from 'vue';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import VueSweetalert2 from 'vue-sweetalert2';
import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon.vue';
import VueMaterial from 'vue-material';
import BootstrapVue from 'bootstrap-vue';
import Vue2Editor from "vue2-editor";

import App from './App.vue';
import router from './router';
import store from './store';
import Layout from './layouts/Layout.vue';
import Admin from './layouts/Admin.vue';
import Video from './layouts/Video.vue';

import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default-dark.css';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'video.js/dist/video-js.css';
//import 'vue-video-player/src/custom-theme.css';
import 'videojs-overlay/dist/videojs-overlay.css';
import 'videojs-watermark/src/plugin.scss';
import 'verte/dist/verte.css';

import './assets/main.scss';

axios.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// This line here
Vue.use(VueMaterial);
Vue.use(BootstrapVue);
Vue.use(Vue2Editor);

Vue.component('v-icon', Icon);
Vue.component('default-layout', Layout);
Vue.component('admin-layout', Admin);
Vue.component('video-layout', Video);

Vue.config.productionTip = false;
Vue.use(VeeValidate);
Vue.use(VueSweetalert2);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');